const TAB_CLASS = 'nui-tab';
const TAB_INDICATOR = `${TAB_CLASS}-indicator`;
const TAB_LIST = `${TAB_CLASS}-list`;
const TabClasses = {
  TAB: TAB_CLASS,
  TAB_ICON: `${TAB_CLASS}-icon`,
  TAB_INDICATOR,
  TAB_INDICATOR_WRAPPER: `${TAB_INDICATOR}-wrapper`,
  TAB_LIST,
  TAB_LIST_SINGLE: `${TAB_LIST}-single`,
  TAB_PANEL: `${TAB_CLASS}-panel`,
  TAB_TAG: `${TAB_CLASS}-tag`
};

export { TabClasses };
